// removed by extract-text-webpack-plugin
module.exports = {"quizCounterHolder":"QuizCounter__quizCounterHolder__D2fXc","image":"QuizCounter__image__23Vky","scoreHolder":"QuizCounter__scoreHolder__2vCCg","clone":"QuizCounter__clone__2UoRe","counter":"QuizCounter__counter__gUPod","percentage":"QuizCounter__percentage__2soBY","startedColor":"QuizCounter__startedColor__epl05","countDownAnim":"QuizCounter__countDownAnim__2gv1t","countDown":"QuizCounter__countDown__1RV-X","canvas":"QuizCounter__canvas__250He"};


//////////////////
// WEBPACK FOOTER
// ./src/components/QuizCounter/QuizCounter.css
// module id = 542
// module chunks = 0